/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp5 } from './commonProp5';
import { commonProp4 } from './commonProp4';

export const hockey_sticks_pucks : {[key: string]: Array<[string, string]>} = {
    p_sex: commonProp5,
    p_brand: [
        d("A&R Sport"),
        d("Acra"),
        d("Bauer"),
        d("Brian's"),
        d("Brother"),
        d("CCM"),
        d("Erba"),
        d("Fischer"),
        d("Franklin"),
        d("Green Biscuit"),
        d("Lion"),
        d("MPS"),
        d("Opus"),
        d("Oroks"),
        d("Powerslide"),
        d("Salming"),
        d("Sedco"),
        d("Sherwood"),
        d("shumee"),
        d("Sidelines Sports"),
        d("Spartan"),
        d("St\u0159ida"),
        d("Sulov"),
        d("Tempish"),
        d("TOHOS"),
        d("TPS"),
        d("Warrior"),
        d("Winnwell"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "In\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
